import useSubsequentEffect from '@carvana/merch-react-hooks/useSubsequentEffect';
import EventLocation from '~/constants/dealership/EventLocation';
import usePushToAdobe from '~/hooks/dealership/usePushToAdobe';
import getAdobeEventPageType from '~/utilities/dealership/getAdobeEventPageType';

export default function useTrackAdobeModalEvent(
  isModalOpen: boolean,
  description: string
) {
  const pushToAdobe = usePushToAdobe();

  useSubsequentEffect(() => {
    pushToAdobe({
      event: 'interaction-click',
      interaction: {
        site: 'dealer',
        type: 'nav',
        page: getAdobeEventPageType(),
        location: isModalOpen ? EventLocation.Body : EventLocation.Overlay,
        description: isModalOpen
          ? `${description}-open`
          : `${description}-close`
      }
    });
  }, [description, isModalOpen, pushToAdobe]);
}
